<template>
  <div>
    <div>
      <a :href="downloadFiles[$i18n.locale]" class="link-download" target="_blank">{{$t('medium_grant.budget__1_download_template')}}
        <img class="ml-2" width="25" src="/img/icons/xls.png"> </a>
      <p class="mt-3">{{$t('medium_grant.budget__1_info')}}</p>
    </div>

    <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.budget.template" :file-data="GrantForm.files.budget.template" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="budget.template">
      <div class="row">
        <div class="font-icon-list col-lg-12">
          <div class="font-icon-detail application-button">
            <img width="100" class="xls-icon-big" src="/img/icons/xls.png">
            <h4>{{$t('medium_grant.budget__1_upload_xls')}}</h4>
          </div>
        </div>
      </div>
    </upload-file>

  </div>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        downloadFiles: {
          en: '/files/en/BIOPAMA_AC_MG_budget_template.xls',
          fr: '/files/fr/FR_BIOPAMA_AC_MG_budget_template.xls'
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
